import { Eye, Zap, Flame, Heart } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

const BUBBLES = [
  { id: "views", Icon: Eye, val: "+12 400", key: "ld.bub_views", pos: "-left-20 top-10", c: "#22d3ee", d: "0s" },
  { id: "ready", Icon: Zap, val: "30 s", key: "ld.bub_ready", pos: "-left-16 top-[52%]", c: "#a78bfa", d: "1.6s" },
  { id: "viral", Icon: Flame, val: "96", key: "ld.bub_viral", pos: "-right-24 top-28", c: "#f472b6", d: "0.8s" },
  { id: "likes", Icon: Heart, val: "+2 300", key: "ld.bub_likes", pos: "-right-20 bottom-24", c: "#c084fc", d: "2.4s" },
];

export const StatChips = () => {
  const { t } = useI18n();
  return (
    <div className="lg:hidden grid grid-cols-2 gap-2 mt-5 w-full mx-auto" data-testid="hero-stat-chips">
      {BUBBLES.map(({ id, Icon, val, key, c, d }) => (
        <div key={id} data-testid={`hero-chip-${id}`} className="cx-bubble flex items-center gap-2 rounded-xl px-2.5 py-2" style={{ "--c": c, animationDelay: d }}>
          <span className="grid place-items-center w-7 h-7 rounded-lg shrink-0" style={{ background: `${c}22`, color: c }}><Icon className="w-3.5 h-3.5" /></span>
          <span className="leading-tight min-w-0">
            <span className="block font-display text-sm text-white">{val}</span>
            <span className="block text-[10px] text-slate-400 leading-snug">{t(key)}</span>
          </span>
        </div>
      ))}
    </div>
  );
};

export const StatBubbles = () => {
  const { t } = useI18n();
  return BUBBLES.map(({ id, Icon, val, key, pos, c, d }) => (
    <div key={id} data-testid={`hero-bubble-${id}`} className={`cx-bubble absolute ${pos} z-10 hidden lg:flex items-center gap-3 rounded-2xl px-4 py-3`} style={{ "--c": c, animationDelay: d }}>
      <span className="grid place-items-center w-9 h-9 rounded-xl" style={{ background: `${c}22`, color: c }}><Icon className="w-4 h-4" /></span>
      <span className="leading-tight">
        <span className="block font-display text-lg text-white">{val}</span>
        <span className="block text-[11px] text-slate-400 whitespace-nowrap">{t(key)}</span>
      </span>
    </div>
  ));
};
